import { useOrderInvoiceStore } from '@pages/orders'

import { defineNuxtRouteMiddleware } from '#app'

/** `/orders/{id}/invoice` — another order never shows the previous order's fields or files while it loads. */
export default defineNuxtRouteMiddleware(() => {
  useOrderInvoiceStore().reset()
})
